var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.887 6.414 1.613 7.686l10.366 10.387L22.386 7.687l-1.272-1.274-9.134 9.114-9.093-9.113Z",
    fill: "#303030"
  })));
};
export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMi44ODY4NSA2LjQxNDM1TDEuNjEyNzkgNy42ODU4OEwxMS45NzkyIDE4LjA3MjlMMjIuMzg1NiA3LjY4NzE0TDIxLjExNDEgNi40MTMwOUwxMS45ODAzIDE1LjUyNjZMMi44ODY4NSA2LjQxNDM1WiIgZmlsbD0iIzMwMzAzMCIvPgo8L3N2Zz4K";